import React from "react";
import { useCookies } from "react-cookie";

const LanguageSelector = () => {
  const [cookies, setCookie] = useCookies(["googtrans"]);

  const handleChangeLanguage = () => {
    // Pehle cookie delete karo
    document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"; 

    // New language set karo (toggle between en & ko)
    const newLang = cookies.googtrans === "/en/en" ? "/en/ko" : "/en/en";

    // Nayi cookie set karo
    setCookie("googtrans", newLang, { path: "/" });
    document.cookie = `googtrans=${newLang}; path=/;`;

    // (Agar page reload karna ho to isko uncomment karo)
    window.location.reload();
  };

  return (
    <div className="language-selector">
      <img
        src="/assets/images/languageIcon.png"
        alt="Language Toggle"
        style={{ width: 30, height: 30, cursor: "pointer" }}
        onClick={handleChangeLanguage}
      />
    </div>
  );
};

export default LanguageSelector;
